// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3S-Mf","file":"styles_file__3EtkL"};